import React from 'react';
import cn from './style.module.scss';
export default function GardeniaContainer({ children }: any) {
  return <div className={cn.gardeniaContainer}> {children}</div>;
}
